module.exports = "\n<div class=\"users-management\">\n    <users *ngIf=\"canManageUsers\"></users>\n    <users-groups *ngIf=\"!canManageUsers\"></users-groups>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/authorized/usersRolesManagement/usersManagement/usersManagement.html
// module id = 1869
// module chunks = 0